module.exports = __webpack_public_path__ + "img/votoBlanco.4542d3a4.png";